import { fetchData } from './fetchData';
import { RepairStage } from '../data/RepairStage';

function repairStage(): Promise<RepairStage[]> {
    return fetchData('api/repair_stage', {
        method: 'POST',
        body: JSON.stringify({}),
    })
        .then((res) => res.json())
        .then((resData: RepairStage[]) => resData);
}

export { repairStage };
